import { useConfirmPopoverStore } from "@/shared/stores";
import { getControlResultAttachmentUrl } from "@/spz-api/control-result-comments/control-result-comments";
import type { GetControlResultAttachmentsResponseDto } from "@/spz-api/model";
import { ActivityAttachmentsItem } from "@spz/ui/components/activity-attachments-item";
import { Icon } from "@spz/ui/components/icon";
import { Typography } from "@spz/ui/components/typography";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const ResultDetailAttachmentsListing = ({
  controlId,
  controlResultId,
  isLoading,
  data,
}: {
  controlId: string;
  controlResultId: string;
  isLoading: boolean;
  data: GetControlResultAttachmentsResponseDto[];
}) => {
  const { t } = useTranslation();
  const { openPopover } = useConfirmPopoverStore();

  const [loadingAttachmentId, setLoadingAttachmentId] = useState<string | null>(
    null,
  );

  const handleAttachmentClick = async (attachmentId: string) => {
    setLoadingAttachmentId(attachmentId);
    try {
      const attachmentUrl = await getControlResultAttachmentUrl(
        controlId,
        controlResultId,
        attachmentId,
      );
      window.open(attachmentUrl.url, "_blank");
    } finally {
      setLoadingAttachmentId(null);
    }
  };
  // Map data to match the expected format for ActivityAttachmentsItem
  const attachments = data.map((attachment) => ({
    id: attachment.id,
    name: attachment.name,
    canDelete: false,
    loading: loadingAttachmentId === attachment.id,
    onDeleteClick: (e: React.MouseEvent<HTMLButtonElement>) =>
      openPopover({
        description: t("content_delete_attachment"),
        side: "bottom",
        onConfirm: () => console.log("delete not implemented."),
        anchorElement: e.currentTarget,
      }),
  }));

  if (isLoading) {
    return <div className="h-64 pb-6">Loading...</div>;
  }

  return (
    <div className="h-64 pb-6">
      {!data.length && (
        <div className="flex flex-col justify-center items-start gap-4">
          <Typography className="text-gray-700 font-base text-xs flex items-center">
            <Icon icon="book-text" className="w-4 h-4 mr-2 mb-1" />
            {t("no_attachments")}
          </Typography>
        </div>
      )}

      {data.length > 0 && (
        <ActivityAttachmentsItem
          attachments={attachments}
          onAttachmentClick={handleAttachmentClick}
          className="space-y-4"
        />
      )}
    </div>
  );
};
